// 주로 백엔드에 보낼 때 사용하는 Flag 변수
export const OFFICIAL = 1
export const PRELIMINARY = 2
export const STORE = 3
export const TRYOUT = 4
export const FREEROLL = 5

// 주로 백엔드에서 온 값을 출력할 때 사용하는 Object
export const convertEventTypeAsName = {
    "1": "공식 대회",
    "2": "공식 예선전 대회",
    "3": "매장 대회",
    "4": "트라이아웃 대회",
    "5": "프리롤 대회",
}